import initAnimations from './modules/animation';
import initCollapse from './modules/collapse';
import initForms from './modules/forms';
import initToggle from './modules/toggle';
import initWebpChecker from './modules/webp-checker';
import initModal from './modules/modal';
import initBookingForm from './modules/booking-form';
import initImageSlider from './modules/image-slider';
import initNewsModals from './modules/news';
import initMenuCardClickable from './modules/menu-cards-clickable';
import initCookieConsent from "./modules/cookie-consent";
import CookieConsent from '@inova/cookie-consent';

try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {
    console.error(e);
}

document.documentElement.dataset.js = 'true';

initAnimations();
initCollapse();
initForms();
initToggle();
initWebpChecker();
initModal();
initBookingForm();
initImageSlider();
initMenuCardClickable();
initNewsModals();
initCookieConsent();

window.onload = () => {
  const cookieConsent = new CookieConsent(document);

  setTimeout(() => cookieConsent.showNotice(), 2000);
}
